export type TransportMode = 'SEA' | 'AIR' | 'LAND' | 'RAIL' | 'MULTIMODAL';
export type FreightLegType = 'INLAND_ORIGIN' | 'INTERNATIONAL' | 'INLAND_DESTINATION' | 'HANDLING';

export interface FreightRouteLeg {
  id: string;
  routeId: string;
  legOrder: number;
  origin: string;
  destination: string;
  transportMode: TransportMode;
  legType: FreightLegType;
  ratePerCbm: number;
  ratePerKg: number;
  ratePerContainer: number | null;
  minimumCharge: number | null;
  estimatedDays: number | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  rateHistory?: FreightRateHistory[];
}

export interface FreightRateHistory {
  id: string;
  legId: string;
  ratePerCbm: number;
  ratePerKg: number;
  ratePerContainer: number | null;
  validFrom: string;
  validTo: string | null;
  notes: string | null;
  createdAt: string;
}

export interface FreightRoute {
  id: string;
  tenantId: string;
  name: string;
  originLocation: string;
  destinationLocation: string;
  category?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  legs: FreightRouteLeg[];
}

export interface CreateFreightRouteData {
  name: string;
  originLocation: string;
  destinationLocation: string;
  legs?: CreateFreightRouteLegData[];
}

export interface UpdateFreightRouteData {
  name?: string;
  originLocation?: string;
  destinationLocation?: string;
  isActive?: boolean;
}

export interface CreateFreightRouteLegData {
  legOrder: number;
  origin: string;
  destination: string;
  transportMode?: TransportMode;
  legType: FreightLegType;
  ratePerCbm?: number;
  ratePerKg?: number;
  ratePerContainer?: number | null;
  minimumCharge?: number | null;
  estimatedDays?: number | null;
}

export interface UpdateFreightRouteLegData {
  legOrder?: number;
  origin?: string;
  destination?: string;
  transportMode?: TransportMode;
  legType?: FreightLegType;
  ratePerCbm?: number;
  ratePerKg?: number;
  ratePerContainer?: number | null;
  minimumCharge?: number | null;
  estimatedDays?: number | null;
  isActive?: boolean;
}

export interface IncotermConfig {
  id: string;
  tenantId: string;
  incoterm: string;
  description: string | null;
  paysInlandOrigin: boolean;
  paysInternational: boolean;
  paysInlandDest: boolean;
  paysHandling: boolean;
  paysInsurance: boolean;
  paysDuties: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertIncotermConfigData {
  incoterm: string;
  description?: string | null;
  paysInlandOrigin: boolean;
  paysInternational: boolean;
  paysInlandDest: boolean;
  paysHandling: boolean;
  paysInsurance: boolean;
  paysDuties: boolean;
}

export interface UpdateIncotermConfigData {
  description?: string | null;
  paysInlandOrigin?: boolean;
  paysInternational?: boolean;
  paysInlandDest?: boolean;
  paysHandling?: boolean;
  paysInsurance?: boolean;
  paysDuties?: boolean;
  isActive?: boolean;
}

// Labels for display
export const FREIGHT_LEG_TYPE_LABELS: Record<FreightLegType, string> = {
  INLAND_ORIGIN: 'Flete Interno Origen',
  INTERNATIONAL: 'Flete Internacional',
  INLAND_DESTINATION: 'Flete Interno Destino',
  HANDLING: 'Handling / Manipuleo',
};

export const TRANSPORT_MODE_LABELS: Record<TransportMode, string> = {
  SEA: 'Marítimo',
  AIR: 'Aéreo',
  LAND: 'Terrestre',
  RAIL: 'Ferroviario',
  MULTIMODAL: 'Multimodal',
};

export const INCOTERM_FIELD_LABELS: Record<string, string> = {
  paysInlandOrigin: 'Flete Interno Origen',
  paysInternational: 'Flete Internacional',
  paysInlandDest: 'Flete Interno Destino',
  paysHandling: 'Handling',
  paysInsurance: 'Seguro',
  paysDuties: 'Aranceles',
};
